import { createAction, props } from "@ngrx/store";

export const saveAccessToken = createAction(
  'User.SaveAccessToken',
  props<{
    accessToken: string;
    refreshToken: string;
  }>()
);
